<style lang="sass">

    @import ../../common/styles/mixins
    @import ../../common/styles/settings

    .node-floating
        padding-top: 6rem

</style>


<script>

    export default {

        mounted() {

        }

    }


</script>